import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { LettersApi } from '@shared/api';

interface UseLettersCountStore {
  loading: boolean;
  lettersCount: number | null;
  error: string | null;
  getLettersCount: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useLettersCountStore = create<UseLettersCountStore>((set) => ({
  loading: false,
  lettersCount: null,
  error: null,

  getLettersCount: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await LettersApi.getLettersCount(signal);
      set({ lettersCount: typeof result === 'number' ? result : null, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ lettersCount: null, loading: false, error: null }),
}));
